import ToggleAudio from "components/toggleAudio";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { AudioVisualizer } from "react-audio-visualize";
import styled from "styled-components";
import { Colors } from "utils/colors";

import Typography from "components/typography";
import { IPreviewClip } from "types/ratedfansData";

interface IProps {
  previewClips: IPreviewClip[];
}
const Player = ({ previewClips }: IProps) => {
  const isMobile =
    /iPhone|iPad|iPod|Android|webOS|BlackBerry|Windows Phone/i.test(
      navigator.userAgent
    );

  const [audioBlob, setAudioBlob] = useState<Blob>();
  const visualizerRef = useRef<HTMLCanvasElement>(null);
  const [currentTrackIndex, setCurrentTrackIndex] = useState(0);
  const [currentTime, setCurrentTime] = useState(0);

  const fetchAudio = useCallback(async () => {
    const response = await fetch(previewClips[currentTrackIndex].url);
    const blob = await response.blob();

    console.log(blob, "blob");
    setCurrentTime(0);
    setAudioBlob(blob);
  }, [previewClips, currentTrackIndex]);

  const Next = () => {
    if (currentTrackIndex === previewClips.length - 1) {
      return;
    }
    setCurrentTrackIndex(currentTrackIndex + 1);
    fetchAudio();
  };

  const Prev = () => {
    if (currentTrackIndex === 0) {
      return;
    }
    setCurrentTrackIndex(currentTrackIndex - 1);
    fetchAudio();
  };

  useEffect(() => {
    if (previewClips.length > 0) {
      fetchAudio();
    }
  }, [previewClips]);

  return (
    <Container>
      <PlayContainer>
        <NextPrevContainer onClick={Prev}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            viewBox="0 0 16 16"
            fill="none"
          >
            <path
              d="M14.6672 11.7159V4.28429C14.6672 3.05271 13.6001 2.27423 12.7317 2.87233L8.66732 5.84571V4.74877C8.66732 3.67113 7.68912 2.98996 6.89319 3.5133L1.94823 6.76461C1.12924 7.30308 1.12924 8.69708 1.94822 9.23555L6.89319 12.4869C7.68912 13.0102 8.66732 12.329 8.66732 11.2514V10.1545L12.7317 13.1278C13.6001 13.7259 14.6672 12.9475 14.6672 11.7159Z"
              fill="white"
            />
          </svg>
        </NextPrevContainer>
        <ToggleContainer>
          <ToggleAudio
            file={previewClips[currentTrackIndex].url}
            getCurrentTime={(time) => setCurrentTime(time)}
          />
        </ToggleContainer>
        <NextPrevContainer onClick={Next}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            viewBox="0 0 16 16"
            fill="none"
          >
            <path
              d="M1.33398 11.7159V4.28429C1.33398 3.05271 2.40108 2.27423 3.2694 2.87233L7.33385 5.84571V4.74877C7.33385 3.67113 8.31198 2.98996 9.10798 3.5133L14.0529 6.76461C14.8719 7.30308 14.8719 8.69708 14.0529 9.23555L9.10798 12.4869C8.31198 13.0102 7.33385 12.329 7.33385 11.2514V10.1545L3.2694 13.1278C2.40108 13.7259 1.33398 12.9475 1.33398 11.7159Z"
              fill="white"
            />
          </svg>
        </NextPrevContainer>
      </PlayContainer>
      <AudioWave>
        {audioBlob && (
          <AudioVisualizer
            ref={visualizerRef}
            blob={audioBlob}
            width={isMobile ? 240 : 420}
            height={isMobile ? 20 : 30}
            barWidth={1}
            gap={6}
            barPlayedColor={Colors.yellow400}
            barColor="rgba(255,255,255,0.1)"
            currentTime={currentTime}
          />
        )}
      </AudioWave>
      <TextContainer>
        <Typography size="xs">
          Preview {currentTrackIndex + 1} of {previewClips.length}:
        </Typography>
        <Typography size="xs" weight="medium">
          {previewClips[currentTrackIndex].title}
        </Typography>
      </TextContainer>
    </Container>
  );
};

export default Player;

const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  height: 9rem;
  overflow: hidden;
  position: relative;
`;

const PlayContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2.8rem 1.4rem;
  background-color: ${Colors.grey900};
  height: 100%;
  @media only screen and (max-width: 769px) {
    padding: 2.4rem 1.4rem;
  }
`;

const NextPrevContainer = styled.div`
  width: 1.6rem;
  height: 1.6rem;
  cursor: pointer;
`;

const ToggleContainer = styled.div`
  margin: 0 0.8rem;
`;

const AudioWave = styled.div`
  height: 100%;
  padding: 0 1.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const TextContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  padding: 0.4rem;
  border-radius: 0px 0.8rem;
  background-color: ${Colors.yellow500};
  color: ${Colors.grey700};
  display: inline-flex;
`;
